import { render, staticRenderFns } from "./TurnoverSettingForm.vue?vue&type=template&id=1d3ecc1d&"
import script from "./TurnoverSettingForm.vue?vue&type=script&lang=js&"
export * from "./TurnoverSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports